module.exports = __webpack_public_path__ + "static/DC0-9e406a0b6e8aba9b835efa35b9bd1930.jpg";